<template>
    <div class="flex flex-column gap-2">
        <AdaptersMessage
            :message="$t('lang.templates.disabled_parent_projects_message.text')"
            class="mb-3"
            severity="warn"
        />
        <div v-if="clusterUid" class="flex flex-column gap-1">
            <span class="text-sm text-color-secondary">{{ $t('lang.templates.disabled_parent_projects_message.cluster_label') }}</span>
            <a :href="getClusterUrl" target="_blank" class="text-sm">
                {{ clusterName }}
            </a>
        </div>
        <div v-if="monitoringId" class="flex flex-column gap-1">
            <span class="text-sm text-color-secondary">{{ $t('lang.templates.disabled_parent_projects_message.monitoring_label') }}</span>
            <a :href="getMonitoringUrl" target="_blank" class="text-sm">
                {{ monitoringName }}
            </a>
        </div>
    </div>
</template>

<script>
import AdaptersMessage from "../component/adapters/Message.vue";

export default {
    name: "TemplatesDisabledParentProjectsMessage",
    props: {
        clusterUid: {
            type: String,
            required: false,
            default: null,
        },
        clusterName: {
            type: String,
            required: false,
            default: null,
        },
        monitoringId: {
            type: Number,
            required: false,
            default: null,
        },
        monitoringName: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        getClusterUrl() {
            return sprintf('/%s/clustering-list/%s', window.locale, this.clusterUid);
        },
        getMonitoringUrl() {
            return sprintf('/%s/monitoring-list/%d', window.locale, this.monitoringId);
        },
    },
    components: {
        AdaptersMessage,
    }
}
</script>
